import EventEmitter from 'owa-event-emitter';
import getInitialSxSViewState from 'owa-sxsdata/lib/utils/getInitialSxSViewState';
import { createStore } from 'satcheljs';
var initialStore = {
    viewState: getInitialSxSViewState(),
    extendedViewState: {
        previewMode: 0,
        attachmentId: null,
        selectionSource: 0,
        isCloudy: false,
    },
    editState: {
        mode: 0,
        editAllowed: false,
        itemId: null,
        isDraft: false,
    },
    eventManager: new EventEmitter(),
    pendingPreviewOperation: null,
    pendingNavigation: null,
};
initialStore.viewState.previewPane = null;
export var getStore = createStore('sxsstore', initialStore);
export default getStore();
//# sourceMappingURL=Store.js.map